'use client';

import { OperatingMarginValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorInputsProps {
  values: OperatingMarginValues;
  onValuesChange: (field: keyof OperatingMarginValues, value: number | string) => void;
  translations: ToolsTranslations['operatingMargin'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: CalculatorInputsProps) {
  const handleInputChange = (field: keyof OperatingMarginValues, value: string) => {
    const cleaned = value.replace(/\s/g, '');
    const numValue = parseFloat(cleaned);
    if (!isNaN(numValue) && numValue >= 0) {
      onValuesChange(field, numValue);
    }
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <label htmlFor="operating-income" className="block text-sm font-medium text-gray-700">{translations.operatingIncome}</label>
        <div className="relative">
          <input id="operating-income" type="text" value={values.operatingIncome.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('operatingIncome', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
      <div className="space-y-3">
        <label htmlFor="revenue" className="block text-sm font-medium text-gray-700">{translations.revenue}</label>
        <div className="relative">
          <input id="revenue" type="text" value={values.revenue.toLocaleString('sv-SE')} onChange={(e) => handleInputChange('revenue', e.target.value)} className={inputClass} placeholder="0" />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">{translations.currencySuffix}</span>
        </div>
      </div>
    </div>
  );
}


